export const CLIENT_DELETE_RESET = 'CLIENT_DELETE_RESET'
export const CLIENT_DELETE_SET_ERROR = 'CLIENT_DELETE_SET_ERROR'
export const CLIENT_DELETE_SET_DELETED = 'CLIENT_DELETE_SET_DELETED'
export const CLIENT_DELETE_TOGGLE_LOADING = 'CLIENT_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/client/delete/mutation_types.js